export const ACCEPTANCE_CRITERIA_GATE_ENABLED = 'autoreview_acceptance_criteria_github_enabled';
